import type { I18nOptions } from 'vue-i18n';
import { createI18n } from 'vue-i18n';
import messages from '@intlify/unplugin-vue-i18n/messages';

export const DEFAULT_LOCALE = 'en';
const SUPPORTED_LOCALES = ['en', 'nl'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export function normalizeLocale(locale?: string | null): SupportedLocale {
  if (!locale) return DEFAULT_LOCALE;

  const lowerCaseLocale = locale.toLowerCase();
  const exactMatch = SUPPORTED_LOCALES.find((item) => item === lowerCaseLocale);
  if (exactMatch) return exactMatch;

  const baseLanguage = lowerCaseLocale.split('-')[0];
  const baseMatch = SUPPORTED_LOCALES.find((item) => item === baseLanguage);
  if (baseMatch) return baseMatch;

  return DEFAULT_LOCALE;
}

export function detectSystemLocale(): SupportedLocale {
  if (typeof navigator === 'undefined') return DEFAULT_LOCALE;

  return normalizeLocale(navigator.language || navigator.languages?.[0] || DEFAULT_LOCALE);
}

export function setupI18n() {
  const i18n = createI18n({
    legacy: false,
    locale: DEFAULT_LOCALE,
    fallbackLocale: DEFAULT_LOCALE,
    warnHtmlInMessage: false,
    warnHtmlMessage: false,
    messages: messages as I18nOptions['messages'],

    // ✅ Add localized date/time formats
    // datetimeFormats: {
    //   en: {
    //     short: {
    //       day: '2-digit',
    //       month: 'long',
    //     },
    //     full: {
    //       day: '2-digit',
    //       month: 'long',
    //       year: 'numeric',
    //     },
    //   },
    //   nl: {
    //     date: {
    //       day: '2-digit',
    //       month: 'long',
    //       year: 'numeric',
    //     },
    //     dateShort: {
    //       day: '2-digit',
    //       month: 'short',
    //       year: 'numeric',
    //     },
    //     dateTime: {
    //       day: '2-digit',
    //       month: 'long',
    //       year: 'numeric',
    //       hour: '2-digit',
    //       minute: '2-digit',
    //     },
    //     time: {
    //       hour: '2-digit',
    //       minute: '2-digit',
    //     },
    //   },
    // },
  });

  setI18nLanguage(i18n, DEFAULT_LOCALE);
  return i18n;
}

export const i18n = setupI18n();

export function setI18nLanguage(i18n: any, locale: string) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  i18n.global.locale.value = locale;

  document.querySelector('html')?.setAttribute('lang', locale);

  // Optional: configure language headers for APIs if needed
  // axios.defaults.headers.common['Accept-Language'] = locale;
}
